import Link from "next/link"
import { removeToken } from "lib/Cookies"
import { useEffect } from "react"
import useStore from "components/ui/Context"
import { Layout } from "components/common"

export default function Custom404() {
  const resetUser = useStore().setUser
  useEffect(() => {
    if (window.location.pathname === "/profile") {
      removeToken()
      resetUser(false)
    }
  }, [])
  return (
    <div className="mx-auto mt-10 mb-[100px] px-8  flex flex-col gap-[85px] font-extrabold">
      <Link href="/">
        <div className="flex gap-[10px]">
          <img src="/icons/iconBack.svg" alt="" /> Quay lại trang chủ
        </div>
      </Link>
      <h1 className="font-extrabold text-2xl uppercase text-center">Xin lỗi, không tìm thấy trang yêu cầu</h1>
      <img className="self-center" src="/notFound.svg" alt="" width={435} />
    </div>
  )
}

Custom404.Layout = Layout
